import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import EntryRosterForm from './EntryRosterForm.jsx';
import EntryRosterListContainer from './EntryRosterListContainer.jsx';
import {
  handleCountryChange,
  validateEntryRosterForm,
  handleSaveEntryRosterForm,
  handleCancelClick
} from './actions';

const EntryRosterFormWrapper = reduxForm({
  form: 'adminEntryRosterForm',
  roster: <EntryRosterListContainer />,
  destroyOnUnmount: false
})(EntryRosterForm);

const mapStateToProps = state => ({
  disableState: state.admin.entryDetail.disableState,
  validate: validateEntryRosterForm,
  countries: state.admin.entryDetail.countries,
  states: state.admin.entryDetail.states,
  rosterPositionsQty: state.admin.entryDetail.rosterPositions.length,
  errors: state.shared.error.source
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSaveEntryRosterForm(data)),
  onCancelClick: () => dispatch(handleCancelClick()),
  onCountryChange: value => dispatch(handleCountryChange(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryRosterFormWrapper);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterFormContainer.jsx